<div class="modal-header">
    <h4 class="modal-title">Registro de Producto</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    </button>
</div>
<div class="modal-body">
    <form [formGroup]="form">
        <div class="row d-flex align-items-center">

            <div class="mb-3 col-12 col-sm">
                <label for="nombre">Nombre</label>
                <input type="text" class="form-control" id="nombre" formControlName="nombre"
                    [ngClass]="{'is-invalid': form.controls['nombre'].errors && form.controls['nombre'].touched}">
                <div class="invalid-feedback">
                    Debe ingresar un valor en el campo.
                </div>
            </div>
            <div class="mb-3 col-12 col-sm">
                <label for="codigo_barra">Código de Barras</label><label class="campo-opcional">(Opcional)</label> 
                <input type="text" class="form-control" id="codigo_barra" formControlName="codigo_barra"
                    [ngClass]="{'is-invalid': form.controls['codigo_barra'].errors && form.controls['codigo_barra'].touched}">
                <div class="invalid-feedback">
                    Debe ingresar un valor en el campo.
                </div>
            </div>
            <div class="mb-3 col-12 col-sm">
                <label for="sku">SKU</label><label class="campo-opcional">(Opcional)</label>
                <input type="text" class="form-control" id="sku" formControlName="sku"
                    [ngClass]="{'is-invalid': form.controls['sku'].errors && form.controls['sku'].touched}">
                <div class="invalid-feedback">
                    Debe ingresar un valor en el campo.
                </div>
            </div>
        </div>
        <div class="row">
            <div class="mb-3 col-12 col-sm">
                <label for="precio_venta">Precio de Venta Minorista</label>
                <input type="text" class="form-control" (keypress)="formatter.validateNumber($event)" id="precio_venta" formControlName="precio_venta" (keypress)="formatter.validatePositiveNumber($event)" mask="separator.0" thousandSeparator="." [ngClass]="{'is-invalid': form.controls['precio_venta'].errors && form.controls['precio_venta'].touched}">
                <div class="invalid-feedback">
                    Debe ingresar un valor en el campo.
                </div>
            </div>
            <!-- <div class="mb-3 col-12 col-sm">
                <label for="precio_mayorista">Precio de Venta Mayorista</label>
                <input type="text" class="form-control" (keypress)="formatter.validateNumber($event)" id="precio_mayorista" formControlName="precio_mayorista" (keypress)="formatter.validatePositiveNumber($event)" mask="separator.0" thousandSeparator="." [ngClass]="{'is-invalid': form.controls['precio_mayorista'].errors && form.controls['precio_mayorista'].touched}">
                <div class="invalid-feedback">
                    Debe ingresar un valor en el campo.
                </div>
            </div> -->
            <div class="mb-3 col-12 col-sm">
                <label for="precio_compra">Precio de Compra</label>
                <input type="text" class="form-control" (keypress)="formatter.validateNumber($event)" id="precio_compra" formControlName="precio_compra" (keypress)="formatter.validatePositiveNumber($event)" mask="separator.0" thousandSeparator="." [ngClass]="{'is-invalid': form.controls['precio_compra'].errors && form.controls['precio_compra'].touched}">
                <div class="invalid-feedback">
                    Debe ingresar un valor en el campo.
                </div>
            </div>
        </div>
        <div class="row">
            <div class="mb-3 col-12 col-sm">
                <label for="stock_inicial">Stock Inicial</label><label class="campo-opcional">(Opcional)</label>
                <input type="text" class="form-control" (keypress)="formatter.validateNumber($event)" id="stock_inicial"
                    formControlName="stock_inicial" (keypress)="formatter.validatePositiveNumber($event)" mask="separator.0"
                    thousandSeparator="." [ngClass]="{'is-invalid': form.controls['stock_inicial'].errors && form.controls['stock_inicial'].touched}">
                <div class="invalid-feedback">
                    Debe ingresar un valor en el campo.
                </div>
            </div>
            <div class="mb-3 col-12 col-sm">
                <label for="stock_minimo">Stock Mínimo</label><label class="campo-opcional">(Opcional)</label>
                <input type="text" class="form-control" (keypress)="formatter.validateNumber($event)" id="stock_minimo" formControlName="stock_minimo" (keypress)="formatter.validatePositiveNumber($event)" mask="separator.0" thousandSeparator="." [ngClass]="{'is-invalid': form.controls['stock_minimo'].errors && form.controls['stock_minimo'].touched}">
                <div class="invalid-feedback">
                    Debe ingresar un valor en el campo.
                </div>
            </div>
        </div>
        <div class="d-flex gap-2">
            <div class="mb-3 w-100">
                <label for="categoria_id">Categoría</label><label class="campo-opcional">(Opcional)</label>
                <ng-select [items]="categorias" bindLabel="nombre" bindValue="id"
                    formControlName="categoria_id" [ngClass]="{'is-invalid': form.controls['categoria_id'].errors && form.controls['categoria_id'].touched}">
                </ng-select>
                
                <div class="invalid-feedback">
                    Debe ingresar un valor en el campo.
                </div>
            </div>
            <!-- <div class="mb-3 col-12 col-sm">
                <label for="moneda">Moneda</label>
                <ng-select [items]="moneda" bindLabel="name" bindValue="id"
                    formControlName="moneda" [ngClass]="{'is-invalid': form.controls['moneda'].errors && form.controls['moneda'].touched}">
                </ng-select>
                <div class="invalid-feedback">
                    Debe ingresar un valor en el campo.
                </div>

            </div> -->
            <div class="mt-4">
                <button class="btn btn-primary" (click)="agregarCategoria()"><i class="fas fa-plus"></i></button>
            </div>
        </div>
        <div class="mb-3 col-12 col-sm">
            <label for="descripcion">Descripción</label><label class="campo-opcional">(Opcional)</label>
            <textarea class="form-control" id="descripcion" formControlName="descripcion" rows="3"
                [ngClass]="{'is-invalid': form.controls['descripcion'].errors && form.controls['descripcion'].touched}"></textarea>
            <div class="invalid-feedback">
                Debe ingresar un valor en el campo.
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="guardar()">Registrar</button>
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">Cancelar</button>
</div>